import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ILoginAttempt } from '@models';
import { ODataService } from '@services/generics/odata.service';
import { MapperService } from '@services/mapper.service';

@Injectable()
export class LoginAttemptsService extends ODataService<ILoginAttempt, number> {
    protected _endpoint = 'odata/UserLoginAttempts';
    constructor(http: HttpClient) {
        super(http, MapperService.loginAttemptsMap);
    }
}
